import { render } from "./organizationManagement.vue?vue&type=template&id=83fcd97a"
import script from "./organizationManagement.vue?vue&type=script&lang=js"
export * from "./organizationManagement.vue?vue&type=script&lang=js"

import "./organizationManagement.vue?vue&type=style&index=0&id=83fcd97a&lang=less"
script.render = render

export default script